import { gql } from '@apollo/client';

export const GET_ALL_FAQ = gql
    `query{ allFaq {
    edges{
      node{
        id
        question
        isActive
        answer
      }
    }
}}`

export const GET_ALL_LOOT_FAQ = gql
    `
query {
  allLootFaq {
    edges{
      node{
        id
        question
        isActive
        answer
      }
    }
  }
}`
